import { useMediaQuery } from "@mui/material";
import he from "he";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Close } from "../../../../assets/close.svg";
import { generateFilterUrl } from "../../../customEvents";
import loadingResetGif from "../loading-3.gif";
import loadingGif from "./loading-2.gif";
import style from "./style.module.scss";

const ActiveSelectedFilters = ({ selectedFilters }) => {
  const isMobile = useMediaQuery("(max-width: " + style.mobileBreakpoint + ")");
  const [isResetLoading, setIsResetLoading] = useState(0);
  const [isResetAllLoading, setIsResetAllLoading] = useState(false);

  // React i18next
  const { t } = useTranslation();

  // Reset all filters URL
  const resetUrl = window.location.href.replace(window.location.search, "");

  // Remove one filter
  const removeFilterFromUrl = (filterId) => {
    window.location.replace(generateFilterUrl(filterId, true));
  };

  // Render the filters of the group "filterType"
  const renderFilterGroup = (filterType) => {
    const filters = selectedFilters[filterType]
      ? Object.values(selectedFilters[filterType])
      : [];

    return filters.map((filter) => (
      <div key={filter.id} className={style.activeFilter}>
        {filter.id === isResetLoading ? (
          <img src={loadingGif} alt={`${t("Loading")}...`} loading="lazy" />
        ) : (
          <Close
            onClick={() => {
              setIsResetLoading(filter.id);
              removeFilterFromUrl(filter.id);
            }}
          />
        )}
        <span>{he.decode(filter.title) ?? ""}</span>
      </div>
    ));
  };

  return (
    <div className={style.activeFilters}>
      {isMobile ? (
        <div className={style.mobileLabel}>
          <div className={style.label}>{t("Your selection")} :</div>

          <a
            href={resetUrl}
            className={style.resetButton}
            onClick={() => setIsResetAllLoading(true)}
          >
            {isResetAllLoading ? (
              <img
                src={loadingResetGif}
                alt={`${t("Loading")}...`}
                loading="lazy"
              />
            ) : (
              <Close />
            )}
            <span>{t("Reset filters")}</span>
          </a>
        </div>
      ) : (
        <div className={style.label}>{t("Your selection")} :</div>
      )}

      <div className={style.selectedFilters}>
        {Object.keys(selectedFilters).map(renderFilterGroup)}
      </div>
    </div>
  );
};

export default ActiveSelectedFilters;
